import levels from '@/game/vars/levels';
import layout from '@/game/vars/layout';

export default {
  layout,
  levels,
};
